module.exports = __webpack_public_path__ + "static/media/PaymentScreen.7f6ca380.png";